import { useState } from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useSnackbar } from "notistack";

export default function DownloadExcelButton({ onExport, disabled }) {
  const [exporting, setExporting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = async () => {
    if (!onExport) return;

    try {
      setExporting(true);
      await onExport();
      enqueueSnackbar("Файл Excel сформирован", { variant: "success" });
    } catch (error) {
      console.error("Не удалось сформировать Excel", error);
      enqueueSnackbar("Не удалось сформировать Excel", { variant: "error" });
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<DownloadIcon fontSize="small" />}
      onClick={handleClick}
      disabled={disabled || exporting}
    >
      {exporting ? "Формируем…" : "Выгрузить Excel"}
    </Button>
  );
}
